import React from 'react';
import { SnowflakeIcon, ShieldCheckIcon, MapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { complianceBadges, images } from '../data/site';
const icons = [SnowflakeIcon, ShieldCheckIcon, MapIcon];
export function About() {
  return <section id="about" className="w-full bg-white py-24 lg:py-32" data-id="element-15" data-mp="2tv6jzk7rget0">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10" data-id="element-16" data-mp="2ysy966h0tmti">
        <div className="grid items-start gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20" data-id="element-17" data-mp="33ri06lah1osq">
          <div data-id="element-18" data-mp="38q2yuga2s0f2">
            <Reveal data-id="element-19" data-mp="38ptaex4oi1bh">
              <p className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-ice" data-id="element-20" data-mp="38p1neap5dbwt">
                <span className="h-px w-8 bg-ice" aria-hidden="true" data-id="element-21" data-mp="3dhkzf386ryzi" />
                About Hold Fast Hauling
              </p>
              <h2 className="mt-6 max-w-xl font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-ink sm:text-4xl lg:text-[3.1rem]" data-id="element-22" data-mp="3hkham8vecstf">
                Cold Chain Logistics You Can Count On.
              </h2>
            </Reveal>

            <Reveal delay={0.05} data-id="element-23" data-mp="2lsa5i3cbpodl">
              <div className="mt-8 max-w-xl space-y-5 text-base leading-relaxed text-ink-soft" data-id="element-24" data-mp="2lp4h6qbiqqix">
                <p data-id="element-25" data-mp="2gqtagogisw4x">
                  Founded in 2018 in Davenport, Florida, Hold Fast Hauling operates as the dedicated transportation
                  division of G&amp;D Property Solutions LLC.
                </p>
                <p data-id="element-26" data-mp="27tso0nd0h844">
                  Since expanding into trucking operations in 2021, our focus has remained simple: move
                  temperature-sensitive and time-critical freight safely, efficiently, and without excuses.
                </p>
                <p data-id="element-27" data-mp="2vo3skgno509m">
                  From fresh produce and seafood to frozen goods and finished products, our team understands that every
                  shipment represents a commitment to our customers.
                </p>
                <p data-id="element-28" data-mp="3o7sktpgk8hn5">
                  We maintain strict compliance with federal transportation requirements, comprehensive insurance
                  coverage, professional equipment standards, and disciplined operational procedures.
                </p>
              </div>
            </Reveal>

            <dl className="mt-12 grid gap-4 sm:grid-cols-3" data-id="element-29" data-mp="b457st5fgqz7">
              {complianceBadges.map((badge, i) => {
              const Icon = icons[i];
              return <Reveal key={badge.title} delay={0.05 * i} className="h-full" data-id="element-30" data-mp="1dsp76h6b7vp" data-mpi={i}>
                    <div className="group flex h-full flex-col rounded-2xl border border-line bg-white p-6 transition-[border-color,transform,box-shadow] duration-200 ease-premium hover:-translate-y-1 hover:border-ice/40 hover:shadow-[0_14px_40px_rgba(11,14,17,0.08)]" data-id="element-31" data-mp="3jjoybkeprvak">
                      <Icon className="h-6 w-6 text-ice transition-transform duration-200 ease-premium group-hover:scale-110" aria-hidden="true" data-id="element-32" data-mp="3eldnp7glhgra" />
                      <dt className="mt-5 text-[12px] font-bold uppercase tracking-[0.12em] text-ink" data-id="element-33" data-mp="1cuk4893hkfe0">{badge.title}</dt>
                      <dd className="mt-2.5 text-sm leading-relaxed text-ink-soft" data-id="element-34" data-mp="2xd4ejslriimz">{badge.detail}</dd>
                    </div>
                  </Reveal>;
            })}
            </dl>
          </div>

          <Reveal delay={0.1} className="lg:sticky lg:top-28" data-id="element-35" data-mp="373fj9hd9svux">
            <figure data-id="element-36" data-mp="32b5uw5rt03ur">
              <div className="overflow-hidden rounded-2xl" data-id="element-37" data-mp="32amgv059xzm0">
                <img src={images.dusk} alt="Hold Fast Hauling Freightliner Cascadia and Utility 3000R reefer staged at a distribution facility at dusk" className="aspect-[4/5] w-full object-cover transition-transform duration-500 ease-premium hover:scale-[1.03]" data-id="element-38" data-mp="3gzsn382j4q3e" />
              </div>
              <figcaption className="mt-4 max-w-sm text-sm leading-relaxed text-ink-soft" data-id="element-39" data-mp="3l2owq9a3dbv7">
                Company equipment, company standards — every tractor and reefer in service carries the Hold Fast
                Hauling authority out of Davenport, Florida.
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </div>
    </section>;
}